module.exports = __webpack_public_path__ + "static/img/p-23.fd3fbbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-23.png
// module id = HcP0
// module chunks = 0